// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"73e04997","10":"7d291810","326":"cd34f4d1","611":"b2cfef83","695":"0ea2d5bb","783":"1de5d6c9"}[chunkId] + ".chunk.js";
};